import TrailCard from '@alltrails/cards/components/TrailCard';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import type { PageUITrailResultSection } from '../../../utils/PageUI/pageUI';
import trailFromPageUISection from '../../../utils/PageUI/trailFromPageUISection';
import { usePageUIMapHover } from '../PageUIMapHoverContext/PageUIMapHoverContext';
import styles from './PageUITrailResult.module.scss';

type Props = {
  section: PageUITrailResultSection;
};

export default function PageUITrailResult({ section }: Props) {
  const languageRegionCode = useLanguageRegionCode();
  const { onSectionHover, onSectionHoverEnd } = usePageUIMapHover();

  return (
    <TrailCard
      className={styles.trailResult}
      languageRegionCode={languageRegionCode}
      onCardMouseEnter={() => onSectionHover(section)}
      onCardMouseLeave={onSectionHoverEnd}
      openInNewTab
      trail={trailFromPageUISection(section)}
      variant="small"
    />
  );
}
